export var ruleEngineRelativePath = "/rules";
export var createRuleEngineApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(ruleEngineRelativePath);
    var ruleReorderUrl = "".concat(apiUrl, "/reorder");
    var ruleUrl = function (id) { return "".concat(apiUrl, "/").concat(id); };
    var ruleEnableUrl = function (id) { return "".concat(ruleUrl(id), "/enable"); };
    var ruleDisableUrl = function (id) { return "".concat(ruleUrl(id), "/disable"); };
    return {
        getRules: function () { return http.get(apiUrl); },
        addRule: function (rule) { return http.post(apiUrl, rule); },
        updateRule: function (rule) { return http.put(ruleUrl(rule.id), rule); },
        enableRule: function (rule) { return http.post(ruleEnableUrl(rule.id), rule); },
        disableRule: function (rule) { return http.post(ruleDisableUrl(rule.id), rule); },
        deleteRule: function (rule) { return http.delete(ruleUrl(rule.id)); },
        reorderRules: function (dto) { return http.post(ruleReorderUrl, dto); }
    };
};
//# sourceMappingURL=index.js.map